import { Component, inject, Signal } from '@angular/core';
import { Resolution } from '@api-types/enums/resolution.enum';
import { WidgetType } from '@api-types/enums/widget-type';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';
import { isForecastSeriesFetching } from 'demand-forecasting/store/forecast-series/forecast-series.selectors';
import { selectResolution } from 'demand-forecasting/store/router-state/router.selectors';
import { AbcXyzAnalysisWidgetComponent } from 'insights/widgets/abc-xyz-analysis/abc-xyz-analysis-widget.component';
import { PlanningAccuracyWidgetComponent } from 'insights/widgets/planning-accuracy/planning-accuracy-widget.component';
import { PortfolioTotalsMultiYearWidgetComponent } from 'insights/widgets/portfolio-totals-multi-year/portfolio-totals-multi-year-widget.component';
import { PortfolioTotalsWidgetComponent } from 'insights/widgets/portfolio-totals/portfolio-totals-widget.component';
import { SingleForecastsWidgetComponent } from 'insights/widgets/single-forecasts/single-forecasts-widget.component';
import { YearToDateTrendWidgetComponent } from 'insights/widgets/year-to-date-trend/year-to-date-trend-widget.component';
import { YearlyComparisonWidgetComponent } from 'insights/widgets/yearly-comparison/yearly-comparison-widget.component';

@Component({
  selector: 'pm-insights-page',
  templateUrl: './insights-page.component.html',
  imports: [
    SingleForecastsWidgetComponent,
    PortfolioTotalsWidgetComponent,
    YearToDateTrendWidgetComponent,
    YearlyComparisonWidgetComponent,
    PlanningAccuracyWidgetComponent,
    PortfolioTotalsMultiYearWidgetComponent,
    AbcXyzAnalysisWidgetComponent,
    TranslatePipe,
  ],
})
export class InsightsPageComponent {
  WidgetType = WidgetType;

  private readonly store = inject(Store);

  protected resolution = this.store.selectSignal(selectResolution) as Signal<
    Resolution | undefined
  >;
  protected configuration = this.store.selectSignal(
    ConfigurationsSelectors.selectConfigurationByUrlParam,
  );

  protected isForecastSeriesFetching = this.store.selectSignal(
    isForecastSeriesFetching,
  );
}
